<script lang="ts">
  import type { ShellController } from './shell-controller.svelte';

  const { shell }: { shell: ShellController } = $props();

  let username = $state('');
  let password = $state('');

  function onsubmit(event: SubmitEvent): void {
    event.preventDefault();
    void shell.login(username, password).then(() => {
      // Cleared regardless of outcome: the password is never hashed here, never stored, and
      // should not sit in a DOM node any longer than the request takes.
      password = '';
    });
  }
</script>

<div class="wis-panel wis-panel--sub">
  <form id="login-form" {onsubmit} autocomplete="on">
    <input
      id="login-username"
      type="text"
      placeholder="Username"
      maxlength="35"
      autocomplete="username"
      bind:value={username}
    />
    <input
      id="login-password"
      type="password"
      placeholder="Password"
      maxlength="35"
      autocomplete="current-password"
      bind:value={password}
    />
    <span id="login-error" class="wis-error login__error" role="alert">{shell.loginError}</span>
    <button class="wis-btn login__submit" type="submit" disabled={shell.busy}>Login</button>
  </form>

  <button
    class="wis-btn login__back"
    type="button"
    onclick={() => {
      shell.navigate('pregame');
    }}>Back</button
  >
</div>

<style>
  #login-username,
  #login-password {
    position: absolute;
    left: 35px;
  }

  #login-username {
    top: 209px;
  }

  #login-password {
    top: 277px;
  }

  .login__error {
    position: absolute;
    top: 327px;
    left: 25px;
    width: 250px;
  }

  .login__submit {
    position: absolute;
    top: 383px;
    left: 98px;
    width: 105px;
    height: 40px;
    padding: 0;
  }

  .login__back {
    position: absolute;
    top: 442px;
    left: 91px;
    width: 117px;
    height: 34px;
    padding: 0;
  }
</style>
